import { ClientType, HostPresence, PresenceMessage, PresenceMessageType } from '@playcastdotio/Messaging';
import { remoteHostList } from '../../../stores/shared';

type RemoteHost = (typeof remoteHostList)['currentState']['hosts']['uniqueId'];

export const handlePresenceMessage = (message: PresenceMessage) => {
  console.log('Presence message:', message);

  switch (message.type) {
    case PresenceMessageType.PRESENCE_CHANGED: {
      if (message.clientType !== ClientType.HOST) return;

      const machineId = message.clientId;
      const active = remoteHostList.currentState.hosts[machineId];
      const inactive = remoteHostList.currentState.inactive[machineId];

      const presence = message.presence as HostPresence;
      const remoteHostObj: RemoteHost = {
        remoteId: presence.remoteHostPeerId ?? '',
        uniqueId: machineId,
        displayName: active?.displayName ?? inactive?.displayName ?? '',
        machineId: machineId,
        environment: 'test',
        version: '1.0.0',
        joinedCount: presence.playerCount ?? 0,
        pendingCount: -1,
      };

      delete remoteHostList.currentState.inactive[machineId];
      delete remoteHostList.currentState.hosts[machineId];

      const isOffline = presence.status === 'offline';
      if (isOffline) {
        remoteHostList.currentState.inactive[machineId] = remoteHostObj;
      } else {
        remoteHostList.currentState.hosts[machineId] = remoteHostObj;
      }

      remoteHostList.updateState({
        ...remoteHostList.currentState,
        inactive: { ...remoteHostList.currentState.inactive },
        hosts: { ...remoteHostList.currentState.hosts },
      });
      break;
    }
  }
};

